import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation.service';
import { Translation } from '../../state/models/translations';

@Pipe({
    name: 'translation',
    standalone: false
})
export class TranslationPipe implements PipeTransform {
  constructor(private translateService: TranslationService) {
  }

  transform(index: string, field: string, translations: Translation[]): string {
    return this.translateService.translate(index, field, translations);
  }
}
